<template>
    <section class="MonitLog">
      <h1>Monitor Json</h1>
      <label><input type="checkbox" id="monitorActive" @change="handleChange($event)"> Activar monitor</label><br>
        <div>
          <label for="filter"> Enter serie gps </label>
          <input type="text" name="filter" v-model="filter">
        </div>
        <div class="monitor" v-if="monit.length > 0 && monitor">
          <ul>
            <li v-for="command in showCommands()" >
              <span>
                  {{command}}
              </span>
            </li>
          </ul>
        </div>
    </section>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "Monit",
  data() {
    return {
      monitor: false,
      filter: '',
    };
  },
  computed: {
    ...mapState(["monit"])
  },
  methods: {
    ...mapMutations(["updateMonit"]),
    showCommands(){
      if (this.filter.length) {
        return this.monit.filter((command) => command.includes(`ID=${this.filter}`))
      } else {
        return this.monit
      }
    },
    handleChange(e) {
      this.monitor = e.target.checked
    }
  },
  sockets: {
    resCommandString(data) {
      this.updateMonit(data)
    }
  }
};
</script>

<style type="text/css">
  .monitor {
    overflow-y: scroll;
    max-height: 50rem;
  }
</style>